import React, { Component } from 'react';
import { Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

class AnalysisAndMedicalPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
        analysis: "",
        plan: "",
        recommendations: "",
        load: false
    };
  }
  
  /*
  componentDidMount() {
    this.setState({ load: true }, ()=>{
      this.props.loadAnalysisAndMedicalPlan().then((load) => {
        this.setState({ load: load },()=>{
            console.log("cargar terminada !!");
        });
      }).catch((error)=>{
        console.log(error)
      });
    })    
  }*/

  handlerAnalysis = (analysis) => {
    this.setState({ analysis: analysis });
  }

  handlerPlan = (plan) => {
    this.setState({ plan: plan });
  }

  handlerRecommendations = (recommendations) => {
    this.setState({ recommendations: recommendations });
  }

  render(){
      return (<Col>
        <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
          <div className="card__title">
            <h5 className="bold-text">Análisis y Plan Médico</h5>
          </div>
          <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
            <div className="form__form-group" style={{ margin: 10 }} >
              <span className="form__form-group-label">Análisis</span>
              <div className="form__form-group-field">
                <Field
                  name="textarea-analysis"
                  component="textarea"
                  type="text"
                  value={this.props.AnalysisAndMedicalPlan.analysis}
                  onChange={(e) => {
                    this.props.handlerAnalysis(e.target.value)
                  }}
                />
              </div>
            </div>
            <div className="form__form-group" style={{ margin: 10 }}>
              <span className="form__form-group-label">Plan Médico</span>
              <div className="form__form-group-field">
                <Field
                  name="textarea-medical-plan"
                  component="textarea"
                  type="text"
                  value={this.props.AnalysisAndMedicalPlan.plan}
                  onChange={(e) => {
                    this.props.handlerPlan(e.target.value)
                  }}
                />
              </div>
            </div>
            <div className="form__form-group" style={{ margin: 10 }}>
              <span className="form__form-group-label">Recomendaciones</span>
              <div className="form__form-group-field">
                <Field
                  name="textarea-recommendations"
                  component="textarea"
                  type="text"
                  value={this.props.AnalysisAndMedicalPlan.recommendations}
                  onChange={(e) => {
                    this.props.handlerRecommendations(e.target.value)
                  }}
                />
              </div>
            </div>
          </div>
        </div>
  
      </Col>);
  }
}

export default reduxForm({
    form: `analysis-and-medical-plan-form`, // a unique identifier for this form
})(withTranslation('common')(AnalysisAndMedicalPlan));